import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import es from '@/locales/es.json';

export const LOCALE_STORAGE_KEY = 'radiologox_locale';

export type AppLocale = 'es' | 'en';

export const SUPPORTED_LOCALES: AppLocale[] = ['es', 'en'];

export const DEFAULT_LOCALE: AppLocale = 'es';

function parseStoredLocale(value: string | null): AppLocale | null {
  if (value === 'es' || value === 'en') return value;
  return null;
}

export function getInitialLocale(): AppLocale {
  if (typeof window === 'undefined') return DEFAULT_LOCALE;
  return parseStoredLocale(localStorage.getItem(LOCALE_STORAGE_KEY)) ?? DEFAULT_LOCALE;
}

export const i18n = createI18n({
  legacy: false,
  locale: getInitialLocale(),
  fallbackLocale: DEFAULT_LOCALE,
  messages: { es, en },
});
